import React from "react";
import { Translate } from "components/common/Translate/Translate";
import dynamic from "next/dynamic";

const CropPngFreeWithOnlineImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/CropWebp/CropWebpFreeWithOnlineImagePreviewImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

const CropPngPerfectYourImageImagePreview = dynamic<{image?: string}>(
    () => import("@/components/features/CropWebp/CropWebpPerfectYourImageImagePreview").then((mod) => mod),
    {
        ssr: false,
    },
);

export const CropWebpFreeWithOnline = ({image}: {image?:string}) => {
    return (
        <>
            <div className="flex flex-col md:flex-row items-center ">
                <div className="flex-1 gap-2 hidden md:block">
                    <CropPngFreeWithOnlineImagePreview image={image} />
                </div>
                <div className="flex-1 dark:text-white text-center md:text-left">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="background-focus-title"/>
                    </h2>
      
                    <p className="md:pt-6 md:mt-1 mt-5">
                        <Translate keyName="background-focus-subtitle" />
                    </p>
                    <div className="flex-1 gap-2 md:hidden">
                    <CropPngFreeWithOnlineImagePreview image={image} />
                    </div>
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center mt-20">
                <div className="flex-1 dark:text-white text-center md:text-left order-2 md:order-1">
                    <h2 className="text-24 font-semibold">
                        <Translate keyName="social-media-title" />
                    </h2>
                    <p className="md:pt-6 md:mt-1 mt-5">
                        <Translate keyName="social-media-subtitle" />
                    </p>
                    <div className="flex-1 gap-2 md:hidden">
                        <CropPngPerfectYourImageImagePreview image={image} />
                    </div>
                </div>
                <div className="flex-1 gap-2 hidden md:block order-1 md:order-2">
                    <CropPngPerfectYourImageImagePreview image={image} />
                </div>
            </div>
        </>
    )
};

